import request from './utils/request'

/**
 * 一级渠道-服务渠道统计
 */
export function getServiceChannelStatistics() {
  return request({
    url: '/web/workbench/primaryChannelDataStatistics/serviceChannelStatistics',
    method: 'get'
  })
}

/**
 * 一级渠道-服务文艺家会员统计
 */
export function getArtistMemberStatistics() {
  return request({
    url: '/web/workbench/primaryChannelDataStatistics/artistMemberStatistics',
    method: 'get'
  })
}

/**
 * 一级渠道-服务会员增长趋势
 * @param {{ analyzeType: 'year'|'quarter'|'month', analyzeYear?: string }} params
 */
export function getServiceMemberGrowthTrend(params) {
  return request({
    url: '/web/workbench/primaryChannelDataStatistics/serviceMemberGrowthTrend',
    method: 'get',
    params
  })
}

/**
 * 一级渠道-服务渠道业务增长趋势
 * @param {{ analyzeType: 'year'|'quarter'|'month', analyzeYear?: string }} params
 */
export function getBusinessGrowthTrend(params) {
  return request({
    url: '/web/workbench/primaryChannelDataStatistics/businessGrowthTrend',
    method: 'get',
    params
  })
}

/**
 * 一级渠道-业务办理总览
 */
export function getBusinessHandlingOverviewStatistics() {
  return request({
    url: '/web/workbench/primaryChannelDataStatistics/businessHandlingOverviewStatistics',
    method: 'get'
  })
}

/**
 * 一级渠道-指定类型的子渠道业务办理统计
 * @param {string} channelIdentityType
 */
export function getBusinessHandlingSubChannelStatistics(channelIdentityType) {
  return request({
    url: '/web/workbench/primaryChannelDataStatistics/businessHandlingSubChannelStatistics',
    method: 'get',
    params: { channelIdentityType }
  })
}

/**
 * 一级渠道-服务会员转化统计
 */
export function getServiceMemberConversionStatistics() {
  return request({
    url: '/web/workbench/primaryChannelDataStatistics/serviceMemberConversionStatistics',
    method: 'get'
  })
}
